import { z } from 'zod';
import { PaymentTermsGroup } from '../../constants/payment-terms-group.js';
import { PriceAmountType } from '../../constants/price-amount-type.js';
import { optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
import { PRICE_RULE_CONSTRAINTS } from './constraints.js';
import { isSet } from './is-set.js';
const TERM_AND_GROUP_MESSAGE = 'A cleared cell cannot target both a payment term and a payment terms group.';
// clearPrice addresses one amount row -- either by priceRuleId (the sheet always has this), or by
// the same slice fields setPrice uses (revision doc §9/R3, "clearPrice clears one cell, not the
// rule"). brandId/productTreeId stay required even when priceRuleId is given, mirroring
// SetPriceInput's own always-present header rather than making them conditionally required.
export const clearPriceInputSchema = z
    .object({
    priceRuleId: optionalUuidString('Invalid pricing rule selection.').nullish(),
    brandId: requiredUuidString(`${PRICE_RULE_CONSTRAINTS.brandId.label} is required.`, `Invalid ${PRICE_RULE_CONSTRAINTS.brandId.label.toLowerCase()} selection.`),
    productTreeId: requiredUuidString(`${PRICE_RULE_CONSTRAINTS.productTreeId.label} is required.`, `Invalid ${PRICE_RULE_CONSTRAINTS.productTreeId.label.toLowerCase()} selection.`),
    stateId: optionalUuidString(`Invalid ${PRICE_RULE_CONSTRAINTS.stateId.label.toLowerCase()} selection.`).nullish(),
    brandMarketConfigId: optionalUuidString(`Invalid ${PRICE_RULE_CONSTRAINTS.brandMarketConfigId.label.toLowerCase()} selection.`).nullish(),
    customerId: optionalUuidString(`Invalid ${PRICE_RULE_CONSTRAINTS.customerId.label.toLowerCase()} selection.`).nullish(),
    productId: optionalUuidString(`Invalid ${PRICE_RULE_CONSTRAINTS.productId.label.toLowerCase()} selection.`).nullish(),
    amountTypeId: z.enum(PriceAmountType, 'Invalid amount type selection.'),
    paymentTermsId: optionalUuidString(`Invalid ${PRICE_RULE_CONSTRAINTS.paymentTermsId.label.toLowerCase()} selection.`).nullish(),
    paymentTermsGroupId: z
        .enum(PaymentTermsGroup, 'Invalid payment terms group selection.')
        .nullish(),
})
    .superRefine((value, ctx) => {
    if (isSet(value.paymentTermsId) && value.paymentTermsGroupId != null) {
        ctx.addIssue({
            code: 'custom',
            message: TERM_AND_GROUP_MESSAGE,
            path: ['paymentTermsGroupId'],
        });
    }
});
//# sourceMappingURL=clear-price-input.js.map